import { isRegExp, escapeRegExp, isString, flatten, map } from 'lodash'
import React from 'react'

// https://github.com/iansinnott/react-string-replace

function replaceString(str: string, match: string | RegExp, fn: Function) {
  let curCharStart = 0
  let curCharLen = 0
  if (str === '') return str
  let re = match

  if (!isRegExp(re)) {
    re = new RegExp(`\\b(${escapeRegExp(re)})`, 'gi')
  }
  const result = str.split(re)
  // loop through split string and wrap each matched section in fn
  for (let i = 1, { length } = result; i < length; i += 2) {
    curCharLen = result[i].length
    curCharStart += result[i - 1].length
    result[i] = fn(result[i], i, curCharStart)
    curCharStart += curCharLen
  }
  return result
}

const reactStringReplace = (
  source: string | React.ReactNodeArray,
  match: string | RegExp,
  fn: (match: string, index: number, offset: number) => React.ReactNode
): React.ReactNodeArray => {
  let src = source
  if (!Array.isArray(source)) src = [source]
  return flatten(
    map(src, x => {
      return isString(x) ? replaceString(x, match, fn) : x
    })
  )
}

export default reactStringReplace
